import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#e80028',
                secondary: '#5A3327',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#e80028'
            },
            dark: {
                primary: '#e80028',
                secondary: '#5A3327',
                info: '#4583f4',
                success: '#8BC34A',
                error: '#e80028'
            }
        }
    }
});
